import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/brukere")({
	beforeLoad: () => {
		throw redirect({ to: "/account/admin/brukere" });
	},
});
